import { Spinner } from '@chakra-ui/react'
import { CenterCenter } from './CenterCenter'

export const Loading = () => (
  <CenterCenter>
    <Spinner size={'xl'} />
  </CenterCenter>
)
